import {SELECT} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

// Types
import {string} from '@drivesally/sally-fw/lib/type';

/**
 Compliance
Defleet
Impound
Key
Loaner
Police Possession
Repo
Reserve for Driver
Service Needed
Stolen
 */
export default attribute({
  type: SELECT,
  attribute: 'hold_type',
  api: string,
  label: {
    default: 'Hold Type',
    short: 'Type',
  },
  options: ['Reserve For Driver', 'Defleet', 'Compliance', 'Impound', 'Key', 'Loaner', 'Police Possession', 'Repo', 'Service Needed', 'Stolen', 'Do Not Re-Rent'],
});
